<template>
    <div ref="root">
        <div
            class="references__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="references__inner module__inner">
                <div class="references__inner--main module__inner--main">
                    <div
                        class="references__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text"
                    >
                        <div class="references__inner-col module__inner-col">
                            <div
                                class="references__header module__header"
                                v-bind:class="'bg-color module--color-' + module.appearance.color"
                            >
                                <app-modulebackground
                                    :module-id="module.id"
                                    custom-class="references__background module__background"
                                ></app-modulebackground>
                                <h2
                                    class="references__title module__title font-h2 color-h2"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="references__subtitle module__subtitle font-h3 color-h3"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="references__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="references__inner-row module__inner-row"
                        v-if="items && Array.isArray(items) && items.length > 0"
                    >
                        <div class="references__inner-col module__inner-col">
                            <div
                                v-if="items && Array.isArray(items) && items.length > 0"
                                class="references__references-list module__list"
                            >
                                <div
                                    :data-id="items__value.id"
                                    v-for="(items__value, items__key) in items"
                                    v-bind:key="items__key"
                                    class="references__reference-single module__list-item bg-color"
                                    :class="[
                                        {
                                            'module--color-1':
                                                (items__key % 2 !== 0 &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [2, 3, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-2':
                                                (items__key % 2 !== 0 &&
                                                    [2].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [1, 3].includes(parseInt(getActiveTheme)) &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-3':
                                                (items__key % 2 !== 0 &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 4, 5, 6, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-4':
                                                (items__key % 2 !== 0 &&
                                                    [4].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [4].includes(parseInt(getActiveTheme)) &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-5':
                                                items__key % 2 !== 0 &&
                                                [5].includes(parseInt(module.appearance.color)),
                                            'module--color-6':
                                                (items__key % 2 !== 0 &&
                                                    [6].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [1, 2, 3, 4, 5, 7].includes(
                                                        parseInt(module.appearance.color)
                                                    )),
                                            'module--color-7':
                                                (items__key % 2 !== 0 &&
                                                    [7].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                (items__key % 2 === 0 &&
                                                    [2].includes(parseInt(getActiveTheme)) &&
                                                    [6].includes(parseInt(module.appearance.color)))
                                        }
                                    ]"
                                >
                                    <app-configbar
                                        v-if="editorMode"
                                        :show-data="true"
                                        :show-layout="false"
                                        :show-appearance="false"
                                        v-on:open="
                                            directEditListeditor({
                                                dataSource: 'deha.user.misc.references',
                                                listSubpage: 'References',
                                                module_id: module.id,
                                                listitem_id: items__value.id
                                            })
                                        "
                                        inner
                                    ></app-configbar>

                                    <div
                                        class="references__inner-row module__inner-row"
                                        v-if="items__value.data"
                                    >
                                        <div class="references__inner-col module__inner-col">
                                            <div
                                                class="references__reference-details"
                                                v-bind:class="{
                                                    'container__boxed flex--wrap': [
                                                        1,
                                                        2,
                                                        3
                                                    ].includes(module.layout.type)
                                                }"
                                            >
                                                <div
                                                    class="references__reference-details-col--left"
                                                    v-bind:class="{
                                                        'col__width--half': [1].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                >
                                                    <div
                                                        class="references__inner-row module__inner-row name-row"
                                                        v-if="items__value.data.name"
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div
                                                                class="references__reference-header"
                                                            >
                                                                <h3
                                                                    class="references__reference-title font-h2 color-h2"
                                                                >
                                                                    {{ items__value.data.name }}
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row category-date-row"
                                                        v-if="
                                                            (items__value.data.category ||
                                                                items__value.data.date_month ||
                                                                items__value.data.date_year) &&
                                                                [2, 3].includes(module.layout.type)
                                                        "
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div
                                                                class="references__reference-header-details flex--wrap"
                                                                v-if="
                                                                    [2, 3].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    v-if="
                                                                        [2, 3].includes(
                                                                            module.layout.type
                                                                        ) &&
                                                                            items__value.data
                                                                                .category
                                                                    "
                                                                    class="references__reference-header-details-item references__reference-category border-color font-bold color-p"
                                                                >
                                                                    <span
                                                                        >Kategorie:
                                                                        {{
                                                                            items__value.data
                                                                                .category
                                                                        }}
                                                                    </span>
                                                                </div>

                                                                <div
                                                                    v-if="
                                                                        [2, 3].includes(
                                                                            module.layout.type
                                                                        ) &&
                                                                            items__value.data
                                                                                .date_year
                                                                    "
                                                                    class="references__reference-header-details-item references__reference-year border-color color-p font-bold"
                                                                >
                                                                    <span>Ausführung:</span>
                                                                    <span
                                                                        v-if="
                                                                            items__value.data
                                                                                .date_month
                                                                        "
                                                                        >{{
                                                                            (
                                                                                '0' +
                                                                                items__value.data
                                                                                    .date_month
                                                                            ).substr(
                                                                                (
                                                                                    '0' +
                                                                                    items__value
                                                                                        .data
                                                                                        .date_month
                                                                                ).length - 2
                                                                            ) + '/'
                                                                        }}</span
                                                                    >
                                                                    <span
                                                                        v-if="
                                                                            items__value.data
                                                                                .date_year
                                                                        "
                                                                        >{{
                                                                            items__value.data
                                                                                .date_year
                                                                        }}</span
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row slider-row"
                                                        v-if="
                                                            images(items__value) &&
                                                                [2].includes(module.layout.type)
                                                        "
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div class="references__reference-body">
                                                                <div
                                                                    ref="slider"
                                                                    per-page="2"
                                                                    per-page-lg="2"
                                                                    per-page-md="2"
                                                                    per-page-sm="1"
                                                                    v-bind:class="{
                                                                        slider: [2].includes(
                                                                            module.layout.type
                                                                        )
                                                                    }"
                                                                    class="references__reference-images"
                                                                >
                                                                    <ul
                                                                        class="references__reference-images-list"
                                                                    >
                                                                        <li
                                                                            v-for="(images__value,
                                                                            i) in images(
                                                                                items__value
                                                                            )"
                                                                            v-bind:key="i"
                                                                            class="references__reference-image-item"
                                                                        >
                                                                            <a
                                                                                :href="
                                                                                    generateMediaUrl(
                                                                                        {
                                                                                            id:
                                                                                                images__value.id
                                                                                        }
                                                                                    )
                                                                                "
                                                                                class="references__reference-btn-lightgallery lightgallery"
                                                                                :data-lightgallery-group="
                                                                                    items__value.id
                                                                                "
                                                                            >
                                                                                <app-moduleimage
                                                                                    :data="
                                                                                        images__value
                                                                                    "
                                                                                    :width="375"
                                                                                    :height="250"
                                                                                    :tag="'img'"
                                                                                    :custom-class="
                                                                                        'references__reference-image'
                                                                                    "
                                                                                ></app-moduleimage>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row category-row"
                                                        v-if="
                                                            items__value.data.category &&
                                                                [1].includes(module.layout.type)
                                                        "
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div
                                                                class="references__reference-header-details flex--wrap"
                                                            >
                                                                <div
                                                                    class="references__reference-header-details-item references__reference-category border-color color-p font-bold"
                                                                >
                                                                    <span
                                                                        >Kategorie:
                                                                        {{
                                                                            items__value.data
                                                                                .category
                                                                        }}</span
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row profile-row"
                                                        v-if="items__value.data.profile"
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div class="references__reference-body">
                                                                <div
                                                                    v-if="items__value.data.profile"
                                                                    v-html="
                                                                        items__value.data.profile
                                                                    "
                                                                    class="references__reference-body-row references__reference-profile module__cms color-p"
                                                                    v-bind:class="{
                                                                        'flex--wrap': [3].includes(
                                                                            module.layout.type
                                                                        )
                                                                    }"
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row date-row"
                                                        v-if="
                                                            (items__value.data.date_month ||
                                                                items__value.data.date_year) &&
                                                                [1].includes(module.layout.type)
                                                        "
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div class="references__reference-body">
                                                                <div
                                                                    class="references__reference-body-row references__reference-year border-color font-bold color-p"
                                                                >
                                                                    <span>Ausführung: </span>
                                                                    <span
                                                                        v-if="
                                                                            items__value.data
                                                                                .date_month
                                                                        "
                                                                        >{{
                                                                            (
                                                                                '0' +
                                                                                items__value.data
                                                                                    .date_month
                                                                            ).substr(
                                                                                (
                                                                                    '0' +
                                                                                    items__value
                                                                                        .data
                                                                                        .date_month
                                                                                ).length - 2
                                                                            ) + '/'
                                                                        }}</span
                                                                    >
                                                                    <span
                                                                        v-if="
                                                                            items__value.data
                                                                                .date_year
                                                                        "
                                                                        >{{
                                                                            items__value.data
                                                                                .date_year
                                                                        }}</span
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="references__inner-row module__inner-row link-row"
                                                        v-if="
                                                            (items__value.data.link &&
                                                                items__value.data.link.active) ||
                                                                (items__value.data.link2 &&
                                                                    items__value.data.link2
                                                                        .active) ||
                                                                (items__value.data.link3 &&
                                                                    items__value.data.link3.active)
                                                        "
                                                    >
                                                        <div
                                                            class="references__inner-col module__inner-col"
                                                        >
                                                            <div
                                                                class="references__cta module__cta"
                                                            >
                                                                <app-modulebutton
                                                                    :data="items__value.data.link"
                                                                    :custom-class="
                                                                        'references__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                    "
                                                                ></app-modulebutton>
                                                                <app-modulebutton
                                                                    :data="items__value.data.link2"
                                                                    :custom-class="
                                                                        'references__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                    "
                                                                ></app-modulebutton>
                                                                <app-modulebutton
                                                                    :data="items__value.data.link3"
                                                                    :custom-class="
                                                                        'references__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                                    "
                                                                ></app-modulebutton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    class="references__reference-details-col--right"
                                                    v-bind:class="{
                                                        'col__width--half': [1].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                    v-if="
                                                        images(items__value) &&
                                                            [1].includes(module.layout.type)
                                                    "
                                                >
                                                    <div class="references__reference-images">
                                                        <ul
                                                            class="references__reference-images-list"
                                                            v-bind:class="{
                                                                'flex--wrap': [1].includes(
                                                                    module.layout.type
                                                                )
                                                            }"
                                                        >
                                                            <li
                                                                v-for="(images__value, i) in images(
                                                                    items__value
                                                                )"
                                                                v-bind:key="i"
                                                                class="references__reference-image-item"
                                                            >
                                                                <a
                                                                    :href="
                                                                        generateMediaUrl({
                                                                            id: images__value.id
                                                                        })
                                                                    "
                                                                    class="lightgallery"
                                                                    :data-lightgallery-group="
                                                                        items__value.id
                                                                    "
                                                                >
                                                                    <app-moduleimage
                                                                        :data="images__value"
                                                                        :tag="'div'"
                                                                        :custom-class="
                                                                            'references__reference-image'
                                                                        "
                                                                    ></app-moduleimage>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapActions, mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';
import Configbar from '@/components/assorted/Configbar.vue';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground,
        'app-configbar': Configbar
    },
    methods: {
        ...mapActions(['directEditListeditor']),
        images(items__value) {
            if (
                !('data' in items__value) ||
                !('images' in items__value.data) ||
                Object.keys(items__value.data.images).length === 0
            ) {
                return [];
            }
            let images = toArray(items__value.data.images);
            images = images.filter((i) => i !== undefined && i !== null && i !== '');
            return images;
        }
    },
    computed: {
        ...mapGetters(['getListItems', 'generateMediaUrl', 'editorMode', 'getActiveTheme']),
        items() {
            return this.getListItems('deha.user.misc.references');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
